<template>
  <div
    ref="$block"
    :class="{
      'osk-concierge-modal': true,
      'osk-sticky-right': isDesktop && sticky,
      'osk-sticky-right_hide': isDesktop && hideSticky,
      'osk-sticky-up': !isDesktop && sticky,
      'osk-sticky-up_hide': !isDesktop && hideSticky,
    }"
    :style="{ marginTop: `-${blockHeight}px` }"
  >
    <div class="osk-concierge-modal__content">
      <div class="osk-concierge-modal__title">
        Не нашли, что хотели?
      </div>

      <div class="osk-concierge-modal__text">
        Новые коллекции. Поиск любого товара по всему миру
      </div>

      <UikitButton
        full-width
        @click="openConciergeDialog"
      >
        Создать заявку
      </UikitButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { AnalyticsEvents } from '~/types/analytics';

const props = defineProps<{
  offset: number
}>();

const $block = ref();

const { isDesktop } = useUiBreakpoints();
const { $addEvent } = useNuxtApp();

const { sticky, hideSticky } = useAnimateSticky({
  offset: toRef(props, 'offset'),
  showFirst: true,
});

const { isConciergeDialogOpen } = useConcierge();

const blockHeight = computed(() => $block.value?.clientHeight ?? 0);

function openConciergeDialog() {
  isConciergeDialogOpen.value = true;
  hideSticky.value = true;

  $addEvent(AnalyticsEvents.ClickEvent, {
    item: 'details',
    action: 'shop',
  });
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-concierge-modal {
  position: fixed;
  width: 100%;
  bottom: 75px;
  z-index: 9;
  transform: translateY(100%);

  @include media-query(lg-and-up) {
    display: block;
    width: auto;
    position: sticky;
    padding-right: 52px;
    align-self: end;
    bottom: 52px;
    transform: translateX(100%);
  }

  &__content {
    padding: $indent-medium;
    padding-top: 0;
    background: #fff;

    @include media-query(lg-and-up) {
      padding: $indent-mmedium;
      display: block;
      border-radius: $radius-medium;
      box-shadow: $card-shadow;
      width: 350px;
    }
  }

  &__title {
    display: none;

    @include media-query(lg-and-up) {
      display: block;
      @include font-style($font-size-subheading, normal, $font-weight-bold);
      margin-bottom: $indent-compact;
    }
  }

  &__text {
    display: none;

    @include media-query(lg-and-up) {
      display: block;
      margin-bottom: $indent-medium;
    }
  }
}
</style>
